import { render, staticRenderFns } from "./SocialMediaSchedule.vue?vue&type=template&id=97d5ea2a&"
import script from "./SocialMediaSchedule.vue?vue&type=script&lang=js&"
export * from "./SocialMediaSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports